import {Scroller} from '@shared/Scroller/Scroller';
import {SIMILAR_ARTICLES_ANCHOR_ID} from '@utils/articles/tableOfContents';

import {ArticleType, SimilarArticles} from '@strapi/types/Articles';

import styles from './ArticleSimilarArticles.module.scss';
import ArticleView from './ArticleView';

type Props = {
  similar: SimilarArticles;
  articleUrl: string;
  onSimilarArticleClick?: (article: ArticleType) => void;
};

export default function ArticleSimilarArticles({
  similar,
  articleUrl,
  onSimilarArticleClick,
}: Props) {
  if (!similar.articles.length) return null;

  return (
    <>
      <h2 className={styles.title} id={SIMILAR_ARTICLES_ANCHOR_ID}>
        {similar.title}
      </h2>
      <Scroller variant="grid" classes={{root: styles.scroller}}>
        {similar.articles.map((article) => (
          <ArticleView
            key={article.id}
            article={article}
            articleUrl={articleUrl}
            onSimilarArticleClick={onSimilarArticleClick}
            className={styles.card}
          />
        ))}
      </Scroller>
    </>
  );
}
